<template>
  <v-container>
    <v-row
      v-if="isGetAcceptInfoLoading && acceptInfo && acceptInfo !== null"
      justify="center"
      align="center"
      class="container-row"
    >
      <v-col cols="12" align="center">
        <span class="txt-accept-title">
          {{ `${userName} requested to join ${acceptInfo.wsName}` }}
          <!-- {{ $t('acceptJoinWsTitle', userName, acceptInfo.wsName) }} -->
        </span>
      </v-col>
      <v-col :cols="12" align="center" style="padding-top: 30px">
        <v-avatar :color="userName | iconBackground" class="logo" round size="80">
          <span class="v-avatar-name" v-if="!acceptInfo.userPicture">
            {{ userName | iconFilter }}
          </span>
          <v-img v-else :src="acceptInfo.userPicture" />
        </v-avatar>
      </v-col>
      <v-col :cols="12" align="center" style="padding-bottom: 4px">
        <span class="txt-accept-name">{{ userName }}</span>
      </v-col>
      <v-col :cols="12" align="center" style="padding-top: 0px">
        <span class="txt-accept-email">{{ acceptInfo.userEmail }}</span>
      </v-col>
      <v-col class="container-grant" cols="12" align="center">
        <v-btn :loading="isAcceptLoading" width="320" color="#27cd8b" @click="setAccept">Grant</v-btn>
      </v-col>
      <v-row
        v-if="acceptErrMessage && acceptErrMessage !== null"
        align="center"
        justify="center"
        style="justify-content: center"
      >
        <v-col cols="12" class="container-error" align="center" align-self="center">
          <v-alert dense outlined dark type="error">
            <span class="txt-accept-error" v-html="acceptErrMessage" />
          </v-alert>
        </v-col>
      </v-row>
    </v-row>
    <v-row v-else-if="infoText && infoText !== null" justify="center" align="center" class="container-row">
      <v-spacer />
      <v-col cols="12" align="center">
        <!-- <router-link to="/"> -->
        <v-img @click="goMain" :src="logo" width="97" height="60" />
        <!-- </router-link> -->
      </v-col>
      <v-spacer />
      <v-col cols="12">
        <div class="no-access-content" v-html="infoText" />
      </v-col>
      <v-spacer />
    </v-row>
  </v-container>
</template>

<script>
import logo from '@/assets/img/tape-logo.png'
// import { setPublicAccept } from '@/services/api'
import { getWsAccept, setWsAccept } from '@/services/api'

export default {
  name: 'Accept',
  created() {
    try {
      let params = new URLSearchParams(window.location.search)
      let decordedParams = ''
      if (params && params !== null) decordedParams = params.toString()
      decordedParams = window.btoa(decordedParams)
      decordedParams = window.atob(decordedParams)
      decordedParams = new URLSearchParams(decordedParams)
      this.wsId = decordedParams.get('wsId')
      this.userId = decordedParams.get('userId')
      this.invite = decordedParams.get('invite')
    } catch (error) {
      console.log()
    }

    // 초대받아서 가입하는 경우 호출
    if (this.invite !== undefined && this.invite !== null && this.invite === 'Y') this.setAccept()
    // 가입이 아닌 수락 화면일 경우에만 호출
    else this.getAcceptInfo()
  },
  data() {
    return {
      infoText: null,
      acceptErrMessage: null,
      logo: logo,
      wsId: null,
      userId: null,
      invite: null,
      acceptInfo: null,
      isGetAcceptInfoLoading: false,
      isAcceptLoading: false,
    }
  },
  methods: {
    goMain() {
      location.href = 'https://www.tape.ooo'
    },
    async getAcceptInfo() {
      try {
        this.acceptInfo = await getWsAccept(this, this.wsId, this.userId)
      } catch (err) {
        if (
          err &&
          err !== null &&
          err.response &&
          err.response !== null &&
          err.response.data &&
          err.response.data !== null
        ) {
          switch (err.response.data) {
            case 'wsNotExist':
              this.infoText = `The workspace was not found.<br />Please try again or contact us at support@tape.ooo`
              break
            case 'userNotExist':
              this.infoText = `The user was not found.<br />Please try again or contact us at support@tape.ooo`
              break
            default:
              this.infoText = this.$t('general.seriousError')
              break
          }
        } else this.infoText = this.$t('general.seriousError')
      } finally {
        this.isGetAcceptInfoLoading = true
      }
    },
    async setAccept() {
      this.acceptErrMessage = null
      if (this.invite !== undefined && this.invite !== null && this.invite === 'Y') {
        this.$store.dispatch('setFirebaseLog', {
          eventName: 'screen_view',
          eventParam: {
            firebase_screen: '워크스페이스 초대 수락',
            firebase_screen_class: 'AcceptInvite',
          },
        })
        this.$router.push({ name: 'Workspace', params: { isJoinOrCreate: true } }).catch(() => {})
      } else {
        if (this.$store.getters.userInfo && this.$store.getters.userInfo !== null) {
          try {
            this.isAcceptLoading = true
            let result = await setWsAccept(this, this.wsId, undefined, this.userId)
            this.acceptInfo = null
            this.infoText = result && result.userId ? this.$t('completedAcceptJoinWs') : this.$t('general.seriousError')
          } catch (err) {
            if (
              err &&
              err !== null &&
              err.response &&
              err.response !== null &&
              err.response.data &&
              err.response.data !== null
            ) {
              switch (err.response.data) {
                case 'userAlreadyJoined':
                  this.acceptErrMessage = `${this.userName} is already a member of the workspace.`
                  break
                case 'managerNotExist':
                  this.acceptErrMessage = this.$t('notManagerErrorMsg')
                  break
                case 'noPermission':
                  this.acceptErrMessage = this.$t('notManagerErrorMsg')
                  break

                default:
                  this.infoText = this.$t('general.seriousError')
                  break
              }
            } else this.infoText = this.$t('general.seriousError')
          } finally {
            this.$store.dispatch('setFirebaseLog', {
              eventName: 'screen_view',
              eventParam: {
                firebase_screen: '워크스페이스 요청 수락',
                firebase_screen_class: 'Accept',
              },
            })
            this.isAcceptLoading = false
          }
        } else {
          this.$store.dispatch('setSignInRedirectUrl', `${location.pathname}${location.search}`)
          this.$router.push({ name: 'SignIn' })
        }
      }
    },
  },
  computed: {
    userName() {
      return this.acceptInfo.userDisplayName || this.acceptInfo.userFullName
    },
  },
}
</script>
<style scoped>
.no-access-content {
  font-style: normal;
  font-weight: 500;
  font-size: 24px;
  line-height: 32px;
  align-items: center;
  text-align: center;
  color: #96a7af;
}
.v-avatar-name {
  color: #ffffff;
  font-size: 48px;
  text-align: center;
}
.container-row {
  margin-top: 150px;
}
.txt-accept-title {
  font-size: 28px;
  color: white;
  text-align: center;
  font-weight: 700;
}
.txt-accept-name {
  font-size: 18px;
  color: white;
  text-align: center;
  font-weight: 500;
}
.txt-accept-email {
  font-size: 18px;
  color: #96a7af;
  text-align: center;
  font-weight: 500;
}
.txt-accept-error {
  font-size: 16px;
  color: #ff464f;
  text-align: center;
  font-weight: 500;
}
.container-grant {
  margin-top: 20px;
}
.v-alert {
  border-color: #ff464f !important;
}
.v-alert >>> i {
  color: #ff464f !important;
}
.container-grant >>> .v-btn * {
  font-size: 18px;
  color: white;
  letter-spacing: 0;
  text-transform: none;
  font-weight: bold;
}
.container-error {
  max-width: 320px;
  margin-top: 20px;
  text-align: center;
  padding: 0;
}
</style>
